import { render, staticRenderFns } from "./deliveroo-scraping.vue?vue&type=template&id=4dfcea14"
import script from "./deliveroo-scraping.vue?vue&type=script&lang=js"
export * from "./deliveroo-scraping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfcea14')) {
      api.createRecord('4dfcea14', component.options)
    } else {
      api.reload('4dfcea14', component.options)
    }
    module.hot.accept("./deliveroo-scraping.vue?vue&type=template&id=4dfcea14", function () {
      api.rerender('4dfcea14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/deliveroo-scraping.vue"
export default component.exports